$(function () {
    ProjectFunctions.AfterResize();
    ProjectFunctions.OrientationChange();
    MediaQueries.AddUserAgentAsClass();
    // Loads fastclick.js if we're on a touch device
    // this version of Fast click is currently broken, stopping dropdown lists from displaying on touch devices
    //MediaQueries.FastClickInit();
    PageSetup.Init();
    // ProjectFunctions.StickySearch();
    //ProjectFunctions.AnzacTimer();
    //$(".btn-facebook").on("click", function (e) {
    //    e.preventDefault();
    //    var w = 626;
    //    var h = 436;
    //    var winTop = ($(window).height() / 2) - (h / 2);
    //    var winLeft = ($(window).width() / 2) - (w / 2);
    //    window.open("https://www.facebook.com/sharer/sharer.php?s=100&p[url]=" + location.href + "&p[title]=" + document.title + "&p[summary]=" + $(this).data("description") + "&p[images][0]=" + $(this).data("image"), "", "toolbar=0,status=0,top=" + winTop + ",left=" + winLeft + ",width=" + w + ",height=" + h);
    //});
});
var ProjectFunctions;
(function (ProjectFunctions) {
    var isDesktop = true;
    var isTablet = false;
    var isMobile = false;
    function AfterResize() {
        $(window).afterResize(function () {
            isDesktop = MediaQueries.MinWidth("1280px");
            isTablet = MediaQueries.MaxWidth("1279px") && MediaQueries.MinWidth("768px");
            isMobile = MediaQueries.MaxWidth("767px");
            var header = $(".headered-box-content_map");
            var scrollAmmount = Math.abs((header.outerWidth() - 790) / 2);
            if (scrollAmmount > 0)
                header.scrollLeft(scrollAmmount);
            ProjectFunctions.HeaderedBoxes();
        }, true, 200); // bool == runs on load or not, int (miliseconds) == how soon it runs after the resize event has finished
    }
    ProjectFunctions.AfterResize = AfterResize;
    function OrientationChange() {
        if (Modernizr.touch) {
            window.addEventListener("orientationchange", function () {
                setTimeout(function () {
                    // Place any scripts here that need to be run after an orientation change
                }, 200);
            });
        }
    }
    ProjectFunctions.OrientationChange = OrientationChange;
    function StickySearch() {
        var fixedElement = $(".section-search--mini"), fromTopDesktop = 46, fromTopTablet = 46, fromTopMobile = 46, hasSet = false;
        $("#autocomplete-category").on("focus input", function () {
            fixedElement.removeClass("hide-fields");
        });
        $(window).on("scroll load", function () {
            checkPosition();
        });
        // $(window).afterResize(function() {
        //     hasSet = false;
        //     checkPosition();
        // });
        function checkPosition() {
            //var scrollTop = $(window).scrollTop();
            if (isDesktop) {
                isFixed(fromTopDesktop, fixedElement);
            }
            else if (isTablet) {
                isFixed(fromTopTablet, fixedElement);
            }
            else if (isMobile) {
                isFixed(fromTopMobile, fixedElement);
                fixedElement.addClass("hide-fields");
            }
        }
        function isFixed(distanceFromTop, element) {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > distanceFromTop) {
                if (hasSet === false) {
                    element.addClass("is-fixed");
                    if (isDesktop || isTablet) {
                        element.next().css({ "margin-top": element.outerHeight() + "px" });
                    }
                    else {
                        element.css({ "height": (element.find(".search-panel").outerHeight()) + "px" });
                    }
                }
                hasSet = true;
            }
            else {
                element.removeClass("is-fixed").css({ "height": "" });
                element.next().css({ "margin-top": "" });
                hasSet = false;
            }
        }
    }
    ProjectFunctions.StickySearch = StickySearch;
    function ImageMap() {
        $("#ImageMap").find("area").hover(function () {
            var thisClass = $(this).attr("class"), image = $("#" + thisClass);
            image.removeClass("visually-hidden");
        }, function () {
            var thisClass = $(this).attr("class"), image = $("#" + thisClass);
            image.addClass("visually-hidden");
        });
    }
    ProjectFunctions.ImageMap = ImageMap;
    function HeaderedBoxes() {
        var importantContacts = $(".headered-box_important-contacts").first(), importantContactsContent = importantContacts.find(".headered-box-content").first(), 
        //importantContactsHeader = importantContacts.find(".headered-box-header").first(),
        needHelp = $(".headered-box_need-help").first(), needHelpContent = needHelp.find(".headered-box-content").first(); //,
        //needHelpHeader = needHelp.find(".headered-box-header").first();
        if (isMobile) {
            importantContacts.addClass("is-closed");
            importantContactsContent.addClass("visually-hidden");
            needHelp.addClass("is-closed");
            needHelpContent.addClass("visually-hidden");
        }
        else {
            importantContacts.removeClass("is-closed");
            importantContactsContent.removeClass("visually-hidden");
            needHelp.removeClass("is-closed");
            needHelpContent.removeClass("visually-hidden");
        }
    }
    ProjectFunctions.HeaderedBoxes = HeaderedBoxes;
    function HeaderedBoxesClick() {
        var importantContacts = $(".headered-box_important-contacts").first(), importantContactsContent = importantContacts.find(".headered-box-content").first(), importantContactsHeader = importantContacts.find(".headered-box-header").first(), needHelp = $(".headered-box_need-help").first(), needHelpContent = needHelp.find(".headered-box-content").first(), needHelpHeader = needHelp.find(".headered-box-header").first();
        importantContactsHeader.click(function () {
            if (isMobile) {
                importantContacts.toggleClass("is-closed");
                if (importantContactsContent.hasClass("visually-hidden"))
                    slideDown(importantContactsContent);
                else
                    slideUp(importantContactsContent);
            }
        });
        needHelpHeader.click(function () {
            if (isMobile) {
                needHelp.toggleClass("is-closed");
                if (needHelpContent.hasClass("visually-hidden"))
                    slideDown(needHelpContent);
                else
                    slideUp(needHelpContent);
            }
        });
        function slideUp(selector) {
            selector.slideUp("fast", function () {
                selector.addClass("visually-hidden")
                    .slideDown(0);
            });
        }
        function slideDown(selector) {
            selector.slideUp(0, function () {
                selector.removeClass("visually-hidden")
                    .slideDown("fast");
            });
        }
    }
    ProjectFunctions.HeaderedBoxesClick = HeaderedBoxesClick;
    function AnzacTimer() {
        var countDownDate = new Date("Apr 25, 2021 06:00:00").getTime();
        var x = setInterval(function () {
            var now = new Date().getTime();
            var distance = countDownDate - now;
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            $("#anzac-day-d").html(days.toString());
            $("#anzac-day-h").html(hours.toString());
            $("#anzac-day-m").html(minutes.toString());
            $("#anzac-day-s").html(seconds.toString());
            if (distance < 0) {
                clearInterval(x);
                $("#anzac-day-clock").addClass("hide");
                $("#anzac-day-complete").removeClass("hide");
            }
        }, 1000);
    }
    ProjectFunctions.AnzacTimer = AnzacTimer;
})(ProjectFunctions || (ProjectFunctions = {}));
